import Immutable from 'immutable';
import { withdrawalActionTypes as actions } from '~client/constants/actionTypes';

export const defaultState = Immutable.fromJS({
  list: [],
});

const withdrawalReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actions.SET_WITHDRAWAL_METHODS:
      return state.mergeDeep({
        list: action.payload,
      });

    case actions.UPDATE_WITHDRAWAL:
      return state.setIn(['list', action.index], action.payload);

    case actions.DELETE_WITHDRAWAL:
      return state.update('list', list => list.delete(action.index));

    case actions.ADD_WITHDRAWAL:
      return state.update('list', list => list.insert(0, action.payload));

    default:
      return state;
  }
};

export default withdrawalReducer;
